module.exports = __webpack_public_path__ + "static/_thumb_73928.b42b55bf.png";